import type { FaireProductEntity } from "../../entity_types/product";

export const p_efb9fq75zb: FaireProductEntity = {
  token: "p_efb9fq75zb",
  type: "product",
  name: "Wish the Whale Bell to be Made Fresh",
  brandToken: "b_fm55nsdjga",
  brandName: "ULTRAVIOLET BOOKS",
  imageUrl: "https://cdn.faire.com/fastly/ba8682ccfa567e3364c3d57a494b14357f2bfcfc58c04d1c118748747f0f485b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b462f786ef9b1ebf7eddf9e419f170ff8ddb4ae2e44240d71677862ac620f5fc.jpeg",
    "https://cdn.faire.com/fastly/2b5ccf9d750755622a124ebf02bc309f37c4c748aa8415f4ac88c4a18c73712f.jpeg",
    "https://cdn.faire.com/fastly/75def0ad1fc4d32f03eb53845ca386cbf20599bc1c53c8131b01bd0dfbe35c48.jpeg",
    "https://cdn.faire.com/fastly/d50a5a690359f2e75f1292fba82420e3fa1e68b199d20194b19684ddc82fa84a.jpeg",
    "https://cdn.faire.com/fastly/58ebad8176fdf17b9fd8951929e96ae6310a3e324b7487e2c0d9867779a09178.jpeg",
    "https://cdn.faire.com/fastly/248035c56e2292ac6d8bc49c455aa861045af7baf7147dd2571ac962fbb4e640.jpeg",
    "https://cdn.faire.com/fastly/5a948ff1c0d7d67f33103c87e83752704c243476766e2d869d4cf19c036998ae.jpeg",
    "https://cdn.faire.com/fastly/052334b8f62c5fbf1b90c1f0ec0a3bce299aa96916079667327d66d9ced57417.jpeg",
    "https://cdn.faire.com/fastly/13d2feedd29ce5e430961fd4b5de194f215a794bb42efb3679b495a28969f3df.jpeg"
  ],
  priceDollars: 10,
  description: "Some poems touch on whales and most float nearby. It’s a collective wish for the whole container of whales, the ocean, and the concept of protecting and relating to them, to be made fresh.\n\nThe cover is a soft cotton paper. Suminagashi prints represent the echos of whale song. All profits from the sale of this book to be donated to The Ocean Conservancy.\n\nFeaturing: Farnoosh Fathi, Julian Talamantez Brolaski, Matt Runkle, Phil Elverum, Nora Slade, Jesse Ball, Tim Presley, Morgan Ritter, Bradley King, Colter Jacobsen, Sophie Appel, Vikesh Kapoor, Alice Fulmer, Maya Weeks, Rod Roland, Satya Dev Jaggi, Kevin McNamee-Tweed, Indigo Free, Lucia Dillman, Sophia Torres, Marley Chamoi Raab, Heather Yancey, Santo Blanco, Sholto Buck, Catherine Edgerton, Eric Palgon, Rachel Corry, Erren Franklin, Michael Deyermond, Sun Bu-er, Sophie Woodbrinker, Iruka Maria Toro, James Tucker, Lynn Bagley, Walt Whitman, Meg Campbell, Lucas Restivo, Wade Ryff, Fletcher Tucker & Joey Lucero.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:07:01.163Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
